<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Incomplete">
            <ag-grid-angular class="data-grid " [gridOptions]="incompleteGridOptions" [rowData]="incompleteReports"  [attr.aria-label]="widgetTitle + ' - Incomplete'"></ag-grid-angular>
        </tab>
        <tab title="Pending">
            <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="pendingReports"  [attr.aria-label]="widgetTitle + ' - Pending'"></ag-grid-angular>
        </tab>
        <tab title="Returned">
            <ag-grid-angular class="data-grid " [gridOptions]="returnedGridOptions" [rowData]="returnedReports"  [attr.aria-label]="widgetTitle + ' - Returned'"></ag-grid-angular>
        </tab>
        <tab title="Accepted">
            <ag-grid-angular class="data-grid " [gridOptions]="approvedGridOptions" [rowData]="approvedReports"  [attr.aria-label]="widgetTitle + ' - Accepted'"></ag-grid-angular>
        </tab>


    </tabs>
</div>

